import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../components/ui'
import AiChatView from '../components/AiChatView'
import { useAuth } from '../contexts/AuthContext'
import { buildAiPageContext, formatContextForPrompt } from '../utils/aiPageContext'

/**
 * Полноэкранный чат в стиле ЛК.
 */
export default function AiPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()
  const sourcePathname = location.state?.aiContextPathname || '/ai'
  const ctx = useMemo(() => buildAiPageContext(sourcePathname), [sourcePathname])
  const promptHint = useMemo(
    () => location.state?.aiContextPromptHint || formatContextForPrompt(ctx),
    [ctx, location.state?.aiContextPromptHint],
  )
  const summary = location.state?.aiContextSummary || ctx.summary

  return (
    <div className="ai-page-full ai-page-full--companion">
      <div className="ai-page-toolbar">
        <Button type="button" variant="ghost" onClick={() => navigate(-1)}>
          ← Назад в ЛК
        </Button>
      </div>
      <div className="ai-page-content">
        <AiChatView
          title="ИИ-ассистент 2ПБ"
          summary={summary}
          promptHint={promptHint}
          fullPage
          user={user}
        />
      </div>
    </div>
  )
}
